module.exports = __webpack_public_path__ + "img/our-la_header-image_sofi-stadium.c032ac68.jpg";